export { default } from './offer-card';
